import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const CalendarEdit = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.84127 2.30371C6.84127 1.8895 6.50548 1.55371 6.09127 1.55371C5.67706 1.55371 5.34127 1.8895 5.34127 2.30371V2.97042C3.97856 3.37412 3 4.66275 3 6.16083V6.88704V13.6906C3 14.8472 3.57993 15.8723 4.46705 16.468C4.81093 16.6989 5.27689 16.6074 5.5078 16.2635C5.73871 15.9196 5.64713 15.4536 5.30325 15.2227C4.82345 14.9006 4.5 14.3384 4.5 13.6906V7.63704H12.5C12.9142 7.63704 13.25 7.30126 13.25 6.88704C13.25 6.47283 12.9142 6.13704 12.5 6.13704H4.50014C4.51245 5.12257 5.3106 4.33942 6.25 4.33942H14.5833C15.2511 4.33942 15.8434 4.73072 16.1392 5.32592C16.3235 5.69686 16.7736 5.84815 17.1446 5.66382C17.5155 5.4795 17.6668 5.02937 17.4825 4.65843C17.0585 3.80524 16.2785 3.15628 15.3333 2.92821V2.30371C15.3333 1.8895 14.9975 1.55371 14.5833 1.55371C14.1691 1.55371 13.8333 1.8895 13.8333 2.30371V2.83942H6.84127V2.30371ZM16.6965 7.81505C16.4037 7.52215 15.9288 7.52215 15.6359 7.81505L8.97458 14.4763C8.08378 15.3671 7.58333 16.5753 7.58333 17.8351V18.5353C7.58333 18.9495 7.91912 19.2853 8.33333 19.2853H9.0335C10.2933 19.2853 11.5015 18.7848 12.3923 17.894L19.0536 11.2327C19.1942 11.0921 19.2732 10.9013 19.2732 10.7024C19.2732 10.5035 19.1942 10.3127 19.0536 10.1721L16.6965 7.81505ZM10.0352 15.537L16.1662 9.40604L17.4626 10.7024L11.3316 16.8334C10.734 17.431 9.92751 17.7719 9.08372 17.7849C9.09675 16.9411 9.43759 16.1347 10.0352 15.537Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default CalendarEdit
